<script lang="ts" setup>import { ref as _ref } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Keyboard, Mousewheel, Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { customerTestimonials } from '@consumer/stores/customerTestimonials'

import bbbLogoAccredited from '@consumer/assets/images/bbbrating.svg'
import giftlyGuaranteeImage from '@consumer/assets/images/giftly-guarantee-2.png'
import { useTrustpilot } from '@shared/composables/trustpilot'
import miscStarFullIcon from '@consumer/assets/icons/misc/star-full.svg?svgicon'

const trustpilotEl = _ref<HTMLElement>()

useTrustpilot((trustpilotEl))
</script>

<template>
  <div>
    <GCard
      shadow
      class="
        w-full
        !bg-grey-200
        rounded-l-lg
        flex flex-col lg:flex-row-reverse items-stretch justify-items-stretch
        gap-10 lg:gap-16
        p-6 lg:p-12 lg:pb-6
        relative
        testimonial-2-container
      "
    >
      <div class="lg:absolute lg:left-12 lg:w-240px lg:h-260px bg-grey-200 lg:z-2">
        <h2 class="text-2xl lg:text-3xl">
          Customer Testimonials
        </h2>
      </div>
      <div class="h-full w-full">
        <Swiper
          :slidesPerView="1"
          :spaceBetween="40"
          :pagination="{ clickable: true }"
          :keyboard="{ enabled: true }"
          :mousewheel="{
            forceToAxis: true,
          }"
          :modules="[Keyboard, Mousewheel, Pagination, Navigation]"
          :loop="true"
          :navigation="true"
          containerModifierClass="testimonial-2-swiper--"
          :breakpoints="{
            300: {
              spaceBetween: 24,
            },
            1024: {
              spaceBetween: 40
            }
          }"
        >
          <SwiperSlide v-for="(testimonial, i) in customerTestimonials" :key="i">
            <div class="pb-5">
              <div class="flex gap-1 w-full">
                <GIcon v-for="n in testimonial.stars" :key="n" :svg="miscStarFullIcon" class="!h-15px !w-15px"/>
              </div>
              <p class="text-lg lg:text-2xl text-grey-900 pt-5">
                {{ testimonial.quote }}
              </p>
            </div>
            <div class="text-grey-900 text-lg">
              {{ testimonial.author }}
            </div>
            <div class="text-lg text-grey-800 mt-1">
              {{ testimonial.customerType }} ({{ testimonial.location }})
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </GCard>

    <div
      class="w-full flex flex-col lg:flex-row items-center justify-center lg:justify-between
      mt-10 lg:mt-16 px-0 lg:px-12 gap-4"
    >
      <div class="flex items-center gap-2">
        <img :src="giftlyGuaranteeImage" class="w-8 h-8" width="32" height="32px">
        <div class="font-semibold text-base whitespace-nowrap">
          <span class="text-gold">100%</span> Satisfaction Guaranteed
        </div>
      </div>

      <div
        ref="trustpilotEl"
        class="trustpilot-widget pad-bottom-10"
        data-locale="en-US"
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id="5aa773d465a75300015d8d3b"
        data-style-height="24px"
        data-style-width="100%"
        data-theme="light"
      />

      <div class="flex justify-center">
        <img :src="bbbLogoAccredited" height="52" width="137">
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.testimonial-2-swiper {
  &--initialized {
    @apply w-full pb-2.5;

    .swiper-wrapper {
      @apply w-full;

      .swiper-slide {
        @apply w-auto pl-0 lg:pl-240px lg:pr-20;
      }
    }

    .swiper-button-prev {
      @apply hidden;
    }

    .swiper-button-next {
      @apply hidden lg:block h-full w-10 top-0 right-0 bg-grey-300;

      --swiper-navigation-color: #737373;
      --swiper-navigation-size: 24px;

      .swiper-navigation-icon {
        @apply absolute top-1/2 left-1/2 h-6 w-6 transform -translate-x-1/2 -translate-y-1/2;
      }
    }

    .swiper-pagination {
      bottom: -10px;
      position: relative;
      text-align: left;

      .swiper-pagination-bullet-active {
        @apply bg-gold;
      }
    }
  }
}
</style>
